<!-- @format -->

<div
	class="hmf-h-100 hmf-w-100 hmf-px-s hmf-flex-display hmf-flex-column hmf-justify-content-center hmf-align-items-center hmf-text-align-center hmf-align-self-stretch">
	<h1 class="hmf-header-bold-l hmf-mb-xs">No products to compare</h1>
	<p class="hmf-body-l hmf-mb-l">
		Close Product Comparison to select products for side-by-side viewing.
	</p>
	<button
		hmf-button
		[variant]="'primary'"
		(click)="onCloseDrawer()">
		Close Product Comparison
	</button>
</div>
